import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { LoadingBase } from 'Components/';
import * as POSSelectors from 'PointOfSale/selectors';
import TeacherServingContainer from 'PointOfSale/modules/teacher/container/TeacherServingContainer';
import LookUpContainer from 'PointOfSale/modules/lookup/container/LookUpContainer';

class TeacherContainer extends Component {
  render() {
    const {
      showLookUp,
      loading,
      writing,
      numProcessing,
      numProcessed,
    } = this.props;
    if (loading || writing) {
      const message = writing
        ? `Processed ${numProcessed} / ${numProcessing} students`
        : 'Loading';
      return <LoadingBase flexible message={message} />;
    }
    if (showLookUp) {
      return <LookUpContainer />;
    }
    return <TeacherServingContainer />;
  }
}

TeacherContainer.propTypes = {
  showLookUp: PropTypes.bool,
  loading: PropTypes.bool,
};

const mapStateToProps = state => ({
  showLookUp: POSSelectors.getShowLookUp(state),
  loading: POSSelectors.getTeacherLoading(state),
  writing: POSSelectors.getTeacherWriting(state),
  numProcessing: POSSelectors.getNumStudentsProcessingForTeacher(state),
  numProcessed: POSSelectors.getNumStudentsProcessedForTeacher(state),
});

export default connect(mapStateToProps)(TeacherContainer);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/teacher/container/TeacherContainer.js